import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const SpeakerIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <g clipPath="url(#clip0_548_4594)">
      <path
        d="M1.375 13.5H6.625C7.39623 13.5 8.13035 13.8405 8.66699 14.4365C9.20259 15.0317 9.5 15.835 9.5 16.667V18.125C9.5 18.2631 9.38807 18.375 9.25 18.375C9.11193 18.375 9 18.2631 9 18.125V16.667C9 15.952 8.74405 15.2708 8.2959 14.7725V14.7715L8.14355 14.6172C7.77615 14.2739 7.32705 14.0645 6.85547 14.0127L6.82812 14.0107L6.65234 14.001L6.63867 14H1.375C0.754151 14 0.15203 14.2738 -0.295898 14.7715V14.7725C-0.744055 15.2708 -1 15.952 -1 16.667V18.125C-1 18.2631 -1.11193 18.375 -1.25 18.375C-1.38807 18.375 -1.5 18.2631 -1.5 18.125V16.667C-1.5 15.835 -1.20255 15.0327 -0.666992 14.4375C-0.130307 13.8412 0.603559 13.5 1.375 13.5ZM4 5.625C5.32737 5.625 6.44434 6.52538 6.77441 7.74902L6.34961 8.1748C6.19088 7.0172 5.20121 6.125 4 6.125C2.68832 6.125 1.625 7.18832 1.625 8.5C1.625 9.81168 2.68832 10.875 4 10.875C4.6133 10.875 5.17039 10.6404 5.5918 10.2588C5.63437 10.4298 5.6983 10.5946 5.7832 10.748C5.2923 11.1387 4.67502 11.375 4 11.375C2.41218 11.375 1.125 10.0878 1.125 8.5C1.125 6.91218 2.41218 5.625 4 5.625ZM10 1.75H15.5V2.25H10C9.58579 2.25001 9.25 2.58579 9.25 3V7.58594L9.24414 7.70898C9.21578 7.99521 9.08904 8.26447 8.88379 8.46973L7.60352 9.75H15.5V10.25H7.48242C7.08245 10.2497 6.88122 9.76527 7.16504 9.48145L8.53027 8.11621C8.67092 7.97555 8.74988 7.78452 8.75 7.58594V3C8.75 2.30965 9.30965 1.75001 10 1.75ZM12 5.5C12.2761 5.5 12.5 5.72386 12.5 6C12.5 6.27614 12.2761 6.5 12 6.5C11.7239 6.49998 11.5 6.27613 11.5 6C11.5 5.72387 11.7239 5.50002 12 5.5ZM15 5.5C15.2761 5.5 15.5 5.72386 15.5 6C15.5 6.27614 15.2761 6.5 15 6.5C14.7239 6.5 14.5 6.27614 14.5 6C14.5 5.72386 14.7239 5.5 15 5.5Z"
        stroke="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_548_4594">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
